
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qasa",
      function () {
        return require("private-next-pages/qasa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qasa"])
      });
    }
  